import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

const Footer = () => {
  return (
    <div>
		<div className="mt-8 text-center max-w-screen-md mx-auto">
		<h2 className="text-2xl font-bold mb-4">Grow Your Audience on Any Platform</h2>
			<div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-3">
				<div className="flex flex-col items-center mb-4 md:mb-0">
					<i className="fa-brands fa-instagram text-instagram mb-2" style={{fontSize: 'clamp(1.5rem, 3vw, 2.5rem)'}}></i>
					<span className="text-sm font-medium">Dominate Instagram</span>
					<span className="text-xs text-gray-500">More Followers</span>
				</div>
				<div className="flex flex-col items-center mb-4 md:mb-0">
					<i className="fa-brands fa-tiktok text-tiktok mb-2" style={{fontSize: 'clamp(1.5rem, 3vw, 2.5rem)'}}></i>
					<span className="text-sm font-medium">Go Viral on TikTok</span>
					<span className="text-xs text-gray-500">Explosive Growth</span>
				</div>
				<div className="flex flex-col items-center mb-4 md:mb-0">
					<i className="fa-brands fa-youtube text-danger mb-2" style={{fontSize: 'clamp(1.5rem, 3vw, 2.5rem)'}}></i>
					<span className="text-sm font-medium">Master YouTube</span>
					<span className="text-xs text-gray-500">More Subscribers</span>
				</div>
				<div className="flex flex-col items-center mb-4 md:mb-0">
					<i className="fa-brands fa-twitter-x text-dark mb-2" style={{fontSize: 'clamp(1.5rem, 3vw, 2.5rem)'}}></i>
					<span className="text-sm font-medium">Build X Empire</span>
					<span className="text-xs text-gray-500">More Followers</span>
				</div>
			</div>
		  </div>
		
      <Container className="m-6 d-flex flex-column justify-content-center align-items-center text-center">
        <div className="h2 text-instagram ">
          <span className=" text-instagram">✨</span> Take ViralGPT For A Spin <span className=" text-instagram">✨</span>
        </div>
        <div className="text-gray-800">This is the final call! Click the button now and register today.</div>
        <div className="flex justify-center mt-4">
			<a href="/register" className="bg-instagram text-white rounded px-4 font-medium py-3 shadow hover:opacity-90 transition-opacity">
				Blow Up My Profile <i className="ms-2 fa-solid fa-arrow-right"></i>
			</a>
		</div>
      </Container>
      <footer className="bg-gray-800 py-10 text-white">
        <div className="container mx-auto grid grid-cols-1 gap-8 md:grid-cols-2">
          <div>
            <h3 className="text-xl font-bold">ViralGPT</h3>
            <p className="mt-2 text-gray-400">
              The best tool to optimize your social media and save time.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold">Subscribe to our Newsletter</h3>
            <form className="mt-4 flex space-x-2">
              <input
                type="email"
                placeholder="Your email"
                className="w-full rounded-lg border border-gray-600 bg-gray-700 px-4 py-2 text-white focus:outline-none"
              />
              <button
                type="submit"
                className="rounded-lg bg-instagram px-6 py-2 text-white transition"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
        <div className="mt-8 text-center text-gray-500">
          &copy; {new Date().getFullYear()} ViralGPT. All rights reserved.
        </div>

        {/* Add Terms of Service, Privacy Policy, Refund Policy links */}
        <div className="mt-6 text-center text-gray-400">
          <a href="/terms-of-service" className="hover:text-white mr-4">Terms of Service</a>
          <a href="/privacy-policy" className="hover:text-white mr-4">Privacy Policy</a>
          <a href="/refund-policy" className="hover:text-white">Refund Policy</a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
